(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wozoom-product-story"] && !Shopify.designMode) return;
  try {
    
function setupWozoomTabs(root){
  if(root.dataset.tabsReady)return;
  root.dataset.tabsReady='true';
  const nav=root.querySelector('.wz-tabs');const links=[...nav.querySelectorAll('a')];const panels=[...root.querySelectorAll('[data-wz-panel]')];
  nav.setAttribute('role','tablist');
  function activate(hash,focus=false){const chosen=links.find(a=>a.hash===hash)||links[0];links.forEach(a=>{const on=a===chosen;a.setAttribute('role','tab');a.setAttribute('aria-selected',String(on));a.setAttribute('aria-controls',a.hash.slice(1));a.tabIndex=on?0:-1});panels.forEach(p=>{p.hidden='#'+p.id!==chosen.hash;p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby','wz-tab-'+p.id.replace('wz-',''));p.tabIndex=0;if(p.hidden)p.querySelectorAll('video').forEach(v=>v.pause())});if(focus)chosen.focus()}
  links.forEach((a,i)=>{a.addEventListener('click',e=>{e.preventDefault();history.replaceState(null,'',a.hash);activate(a.hash)});a.addEventListener('keydown',e=>{let next;if(e.key==='ArrowRight')next=(i+1)%links.length;if(e.key==='ArrowLeft')next=(i-1+links.length)%links.length;if(e.key==='Home')next=0;if(e.key==='End')next=links.length-1;if(next!==undefined){e.preventDefault();history.replaceState(null,'',links[next].hash);activate(links[next].hash,true)}})});
  window.addEventListener('hashchange',()=>{activate(location.hash);const panel=panels.find(p=>'#'+p.id===location.hash);if(panel)panel.scrollIntoView({block:'start'})});
  document.addEventListener('click',e=>{const a=e.target.closest('.wz-rating-link');if(!a)return;const url=new URL(a.href);if(url.pathname===location.pathname){e.preventDefault();history.replaceState(null,'',url.hash);activate(url.hash);root.querySelector('#wz-reviews').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'})}});
  activate(location.hash);if(location.hash==='#wz-reviews')requestAnimationFrame(()=>root.querySelector('#wz-reviews').scrollIntoView({block:'start'}));
}
document.querySelectorAll('.wz-story').forEach(setupWozoomTabs);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.wz-story').forEach(setupWozoomTabs));

  } catch(e) { console.error(e); }
})();
})();
